// extracted by mini-css-extract-plugin
export default {"error":"SystemMessage_error__nVSKA","warning":"SystemMessage_warning__O5dLP","success":"SystemMessage_success__5jPCi","info":"SystemMessage_info__2q7tw"};